import { useEffect, useState } from "react";
import { Stack, TextField } from "@fluentui/react";
import { Send28Filled } from "@fluentui/react-icons";

import styles from "./QuestionInput.module.css";

interface Props {
    onSend: (question: string) => void;
    disabled: boolean;
    placeholder?: string;
    clearOnSend?: boolean;
    isDarkMode?: boolean;
    uploadedText?: boolean;
    uploadedData?: string;
}

export const QuestionInput = ({ onSend, disabled, placeholder, clearOnSend, isDarkMode, uploadedText, uploadedData }: Props) => {
    const [question, setQuestion] = useState<string>("");

    
    useEffect(() => {
        if (uploadedText) {
            setQuestion(uploadedData || '');
        }
    }, [uploadedText, uploadedData]);
    
    const sendQuestion = () => {
        if (disabled || !question.trim()) {
            return;
        }

        onSend(question);

        if (clearOnSend) {
            setQuestion("");
        }
    };

    const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
        if (ev.key === "Enter" && !ev.shiftKey) {
            ev.preventDefault();
            sendQuestion();
        }
    };

    const onQuestionChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (!newValue) {
            setQuestion("");
        } else if (newValue.length <= 7000) {
            setQuestion(newValue);
        }
    };

    const sendQuestionDisabled = disabled || !question.trim();

    const textFieldStyle = {
        fieldGroup: {
            background: "rgba(0, 0, 0, 0)"
        }
    };

    const textFieldStyleDark = {
        fieldGroup: {
            background: "rgba(0, 0, 0, 0)"
        },
        field: {
            color: "#ececf1",
            "&::placeholder": {
                color: "#ececf1"
            }
        }
    };

    return (
        <Stack horizontal className={isDarkMode ? styles.questionInputContainerDark : styles.questionInputContainer}>
            <TextField
                className={isDarkMode ? styles.questionInputTextAreaDark : styles.questionInputTextArea}
                styles={isDarkMode ? textFieldStyleDark : textFieldStyle}
                placeholder={placeholder}
                multiline
                resizable={false}
                borderless
                value={question}
                onChange={onQuestionChange}
                onKeyDown={onEnterPress}
            />
            <div className={styles.questionInputButtonsContainer}>
                <div
                    className={`${styles.questionInputSendButton} ${sendQuestionDisabled ? styles.questionInputSendButtonDisabled : ""}`}
                    aria-label="Ask question button"
                    onClick={sendQuestion}
                >
                    <Send28Filled primaryFill="rgba(115, 118, 225, 1)" />
                </div>
            </div>
        </Stack>
    );
};
